import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";

const baseUrl = env.REACT_APP_BASE_URL;

export const addInternalAccLabel = createAsyncThunk(
  "addInternalAccLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/internal/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const removeInternalAccLabel = createAsyncThunk(
  "removeInternalAccLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/internal/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const addInternalTxnLabel = createAsyncThunk(
  "addInternalTxnLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/internal/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const removeInternalTxnLabel = createAsyncThunk(
  "removeInternalTxnLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/internal/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const internalAccLabelSlice = createSlice({
  name: "internalAccLabelSlice",
  initialState: {
    storedPage: 1,
    toggle: false,

    internalAccAddLabelsData: null,
    internalAccAddLabelsLoading: false,
    internalAccAddLabelsError: null,

    internalAccRemoveLabelsData: null,
    internalAccRemoveLabelsLoading: false,
    internalAccRemoveLabelsError: null,

    internalTxnAddLabelsData: null,
    internalTxnAddLabelsLoading: false,
    internalTxnAddLabelsError: null,

    internalTxnRemoveLabelsData: null,
    internalTxnRemoveLabelsLoading: false,
    internalTxnRemoveLabelsError: null,
  },

  extraReducers: (builder) => {
    builder.addCase(addInternalAccLabel.fulfilled, (state, action) => {
      state.internalAccAddLabelsLoading = false;
      state.internalAccAddLabelsData = action.payload;
    });
    builder.addCase(addInternalAccLabel.rejected, (state, action) => {
      state.internalAccAddLabelsError = true;
      state.internalAccAddLabelsData = null;
      state.internalAccAddLabelsLoading = false;
    });
    builder.addCase(addInternalAccLabel.pending, (state, action) => {
      state.internalAccAddLabelsLoading = true;
    });

    builder.addCase(addInternalTxnLabel.fulfilled, (state, action) => {
      state.internalTxnAddLabelsLoading = false;
      state.internalTxnAddLabelsData = action.payload;
    });
    builder.addCase(addInternalTxnLabel.rejected, (state, action) => {
      state.internalTxnAddLabelsError = true;
      state.internalTxnAddLabelsData = null;
      state.internalTxnAddLabelsLoading = false;
    });
    builder.addCase(addInternalTxnLabel.pending, (state, action) => {
      state.internalTxnAddLabelsLoading = true;
    });

    builder.addCase(removeInternalTxnLabel.fulfilled, (state, action) => {
      state.internalTxnRemoveLabelsLoading = false;
      state.internalTxnRemoveLabelsData = action.payload;
    });
    builder.addCase(removeInternalTxnLabel.rejected, (state, action) => {
      state.internalTxnRemoveLabelsError = true;
      state.internalTxnRemoveLabelsData = null;
      state.internalTxnRemoveLabelsLoading = false;
    });
    builder.addCase(removeInternalTxnLabel.pending, (state, action) => {
      state.internalTxnRemoveLabelsLoading = true;
    });

    builder.addCase(removeInternalAccLabel.fulfilled, (state, action) => {
      state.internalAccRemoveLabelsLoading = false;
      state.internalAccRemoveLabelsData = action.payload;
    });
    builder.addCase(removeInternalAccLabel.rejected, (state, action) => {
      state.internalAccRemoveLabelsError = true;
      state.internalAccRemoveLabelsData = null;
      state.internalAccRemoveLabelsLoading = false;
    });
    builder.addCase(removeInternalAccLabel.pending, (state, action) => {
      state.internalAccRemoveLabelsLoading = true;
    });
  },
});

export default internalAccLabelSlice.reducer;
